module.exports = __webpack_public_path__ + "static/media/sportAvatar__rl.60a4be08.jpg";